import { createStore } from 'vuex';
import { getDetail } from '@/api/index';
import {
  getIdentification,
  setKeyInLocalStorage,
  getLocalStorage,
  setThemeColor,
} from '@/assets/js/utils';

export default createStore({
  state: {
    appInfo: {
      key: '',
      is_full_screen: 1,
      language_list: {
        basic_info: {},
        about_app: {},
        data_safety: {},
        dialog: {},
        footer: {},
        more: {},
        ratings: {},
      },
    },
  },
  getters: {
    getAppInfo(state) {
      return state.appInfo;
    },
  },
  mutations: {
    setAppInfo(state, appInfo) {
      state.appInfo = appInfo;
    },
  },
  actions: {
    getAppInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        let uuid = '';
        if (getLocalStorage('localData')?.identification) {
          uuid = getLocalStorage('localData').identification;
        }
        getDetail({
          ...params,
          ...{
            uuid: uuid,
          },
        })
          .then((response) => {
            if (response.code === 200) {
              const { data } = response;
              const banner = JSON.parse(data.banner);
              data.banner = banner;
              if (data.tags !== '') {
                data.tags = data.tags.split(',');
              }
              if (data.score_detail !== '') {
                data.score_detail = JSON.parse(data.score_detail);
              }
              if (data.activity !== '') {
                data.activity = JSON.parse(data.activity);
              }
              data.score = Number(data.score);
              document.title = data.name;
              var link = document.createElement('link');
              link.rel = 'icon';
              link.href = data.icon;
              document.getElementsByTagName('head')[0].appendChild(link);

              uuid = getIdentification(data.identification);
              setKeyInLocalStorage('localData', 'identification', uuid);

              let paramsString = '';
              const urlParams = new URLSearchParams(window.location.search);
              const pixel_click_id = urlParams.get('pixel_click_id');
              const _oks_ext = urlParams.get('_oks_ext');
              const code = urlParams.get('code');
              pixel_click_id
                ? (paramsString += `&pixel_click_id=${pixel_click_id}`)
                : '';
              _oks_ext ? (paramsString += `&_oks_ext=${_oks_ext}`) : '';
              code ? (paramsString += `&code=${code}`) : '';

              let href = `/manifest.json?uuid=${uuid}`;
              if (paramsString !== '') {
                href = `/manifest.json?uuid=${uuid}${paramsString}`;
              }
              document.getElementById('manifest').href = href;
              setThemeColor(data.color);
              commit('setAppInfo', data);
              resolve(data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  modules: {},
});
